export enum BatchEventTypeEnum {
    DataDeadline = 10,
    AutoCoding = 30,
    CodingDeadline = 40,
    AuditingDeadline = 50,
    AnalysisDeadline = 60,
    ReportAvailable = 70
}

export enum BatchEventDateTypeEnum {
    CreateDate = 0,
    ScheduledDate = 1,
    ProcessedDate = 2,
    StartDate = 3,
    EndDate = 4
}
